import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import LoadingSpinner from "../../shared/LoadingSpinner";
import persianDate from "persian-date";
import { splitDate } from "../../../utils/splitDate";
import { requestCanceller } from "../../../service/axiosCancelToken";
import { getSummaryViews } from "../../../service/viewerService";
persianDate.toLocale('en');

const Weekly = () => {
    const [items, setItems] = useState();
    // const allDocs = useRef(null);
    const history = useHistory();

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllViews = async () => { 
            try {
                let { status, data } = await getSummaryViews({cancelToken: cancelRequest.signal});
                if (status === 201) {
					let allWeeks = [];
					let week = {
                        _id: '',
                        totalViewers: 0
                    }
					data.allDocs.forEach( day => {
						if(week._id === ''){
                            let newDate = splitDate(day._id);
                            week._id =new persianDate([
                                Number(newDate.year), 
                                Number(newDate.month), 
                                Number(newDate.day)
                            ]).startOf('week').format('YYYY/MM/DD');
                        }

						let splitedCurrentDay = splitDate(day._id);
						let currentDay = new persianDate([
							Number(splitedCurrentDay.year), 
							Number(splitedCurrentDay.month), 
							Number(splitedCurrentDay.day)
                        ]).startOf('week');
                        

						let splitedFirstOfWeek = splitDate(week._id);
						let firstOfWeek = new persianDate([
							Number(splitedFirstOfWeek.year),
							Number(splitedFirstOfWeek.month),
							Number(splitedFirstOfWeek.day)
                        ]).startOf('week');
                        
						if(persianDate.isSameDay(firstOfWeek, currentDay)){
                            // day.viewers.forEach(element => {
                            //     week.viewers.push(element)
                            // })
                            week.totalViewers += day.total;
						}
						else{
                            let splitedFirstOfWeek = splitDate(week._id);
                            let weekEnd = new persianDate([
                                Number(splitedFirstOfWeek.year), 
                                Number(splitedFirstOfWeek.month), 
                                Number(splitedFirstOfWeek.day)
                            ]).startOf('week').add('days',6);

                            week._id = `${week._id} تا ${weekEnd.format('YYYY/MM/DD')}`;
                            allWeeks.push({...week});
                            
                            // end previous week
                            week.totalViewers  = 0;
                            let newDate = splitDate(day._id);
                            week._id =new persianDate([
                                Number(newDate.year), 
                                Number(newDate.month), 
                                Number(newDate.day)
                            ]).startOf('week').format('YYYY/MM/DD');
                            // week.viewers = [...day.viewers]
                            week.totalViewers += day.total;
                        }
                    });
                    // last Element
                    let splitedFirstOfWeek = splitDate(week._id);
                    let weekEnd = new persianDate([
                        Number(splitedFirstOfWeek.year), 
                        Number(splitedFirstOfWeek.month), 
                        Number(splitedFirstOfWeek.day)
                    ]).startOf('week').add('days',6);

                    week._id = `${week._id} تا ${weekEnd.format('YYYY/MM/DD')}`;
                    allWeeks.push({...week});

                    // the end
					// allDocs.current = allWeeks;
                    setItems(allWeeks);
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    history.replace('/user/login');
                }
            }
        }
        fetchAllViews();
        return () => {
			cancelRequest.cancel();
		}
        // es
    }, [history])


    return (
        <React.Fragment>
            <div className=" text-light mt-4">
                <div
                    id="scrollableDiv"
                    style={{ height: "400px", overflowY: "scroll", direction: "ltr" }}>
                    {
                        (items && items.length > 0) ?

                            items.map(item => (
                                <div className="rtl all_view_item" key={item._id}>
                                    <div className="  d-flex justify-content-between">
                                        <div className="col-7 text-left px-0">
                                            <span className="font-weight-bold pt-2">{item._id}</span>
                                        </div>
                                        <div className="col-5 text-right">
                                            <span className="badge badge-success badge-pill">{item.totalViewers}</span>
                                        </div>
                                    </div>
                                </div>

                            ))
                            :
                            <div style={{ height: '55vh' }} className="d-flex">
                                <div className="text-center align-self-center mx-auto">
                                    <LoadingSpinner />
                                </div>
                            </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default Weekly;
